import type { GenerateGroupItemImageDetailResponse, GenerationType } from '@/common/api/client/types.gen'

const GENERATION_TYPE_LABELS: Record<GenerationType, string> = {
    background_removal: 'Удаление фона',
    background_replacement: 'Замена фона',
    image_validation: 'Проверка изображения',
    card_validation: 'Валидация карточки',
    card_validation_ro_re: 'Валидация карточки (RO/RE)',
    card_title_description: 'Заголовок и описание карточки',
    generate_hp_image: 'Hero Ppackshot',
    generate_ls_image: 'Lifestyle',
    generate_prompt: 'Генерация промпта',
    generate_ig_image: 'Инфографика',
    generate_image_prompt: 'Генерация промпта изображения',
}

export type GroupGenerationItemWithOverlay = GenerateGroupItemImageDetailResponse & {
    text_on_image?: string | null
}

export const formatGroupGenerationItemDisplayType = (item: GenerateGroupItemImageDetailResponse): string => {
    const base = GENERATION_TYPE_LABELS[item.type] ?? item.type
    const imageType = item.image_type
    if (!imageType) {
        return base
    }
    return `${base}${item.image_name ? ` — ${item.image_name}` : ''}`
}
